import React, { useContext, useMemo } from 'react';

type ChatMessageContextType = {
  isIncoming: boolean;
};

const ChatMessageContext = React.createContext<
  ChatMessageContextType | undefined
>(undefined);

type ChatMessageProviderProps = {
  isIncoming: boolean;
  children: React.ReactNode;
};

export const ChatMessageProvider = ({
  children,
  isIncoming,
}: ChatMessageProviderProps) => {
  const value = useMemo(
    () => ({
      isIncoming,
    }),
    [isIncoming]
  );

  return (
    <ChatMessageContext.Provider value={value}>
      {children}
    </ChatMessageContext.Provider>
  );
};

export const useChatMessageContext = () => {
  const context = useContext(ChatMessageContext);

  if (context === undefined) {
    throw new Error(
      'useChatMessageContext is use outside of the ChatMessageProvider'
    );
  }

  return context;
};
